/*
  Révélation mot à mot au défilement.
  Tout élément [data-word-reveal] est découpé en mots (balises internes
  conservées : <em>, <strong>…). Sa progression --p (0 → 1) suit son
  passage dans l'écran : début quand son haut atteint 85 % de la hauteur
  d'écran, fin quand il atteint 35 %. Chaque mot porte son rang --i ;
  l'opacité, le flou et le léger déplacement sont calculés en CSS
  (voir « RÉVÉLATION MOT À MOT » dans tdm-polish.css).
  « Réduire les animations » : rien n'est découpé, le texte reste normal.
*/
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const split = (root) => {
    let index = 0;
    const walk = (node) => {
      [...node.childNodes].forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          const fragment = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) {
              fragment.append(part);
              return;
            }
            const word = document.createElement('span');
            word.className = 'tdm-reveal-word';
            word.style.setProperty('--i', index++);
            word.textContent = part;
            fragment.append(word);
          });
          child.replaceWith(fragment);
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          walk(child);
        }
      });
    };
    walk(root);
    root.style.setProperty('--n', Math.max(index, 1));
    root.classList.add('is-word-split');
  };

  const items = [];
  let ticking = false;

  const update = () => {
    ticking = false;
    const vh = window.innerHeight;
    items.forEach((el) => {
      const top = el.getBoundingClientRect().top;
      const progress = Math.min(Math.max((vh * 0.85 - top) / (vh * 0.5), 0), 1);
      el.style.setProperty('--p', progress.toFixed(4));
    });
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  };

  const init = () => {
    document.querySelectorAll('[data-word-reveal]:not(.is-word-split)').forEach((el) => {
      split(el);
      items.push(el);
    });
    update();
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Éditeur de thème : sections rechargées à la volée */
  document.addEventListener('shopify:section:load', init);
})();
